import { Channel } from "../agptesting-newview/model/channel";
import { Result } from "../agptesting-newview/model/resultGroups";

export class ShipToSenderDTO {
  labId: string;
  sample: string;
  batchID: string;
  destination: string;
  shippedUserPUID: string;
  shippedTimestamp: Date;
}

export class ResultViewDTO {
  channelTestingTypeMapping : any[];
  samples : SampleResultViewDTO;
}
export class SampleResultViewDTO {
  positionRow : number;
  prositionCol : number;
  channels : any[];
  results : any[];
  result : string;
  wellQuadrant : string;
}


export class SampleHistoryInformationDto {
    batchId : string;
    batchStatus : string;
    rtPCRKitVendor : string;
    sampleResult : string;
    wellQuadrant : string;
    unBoxedSampleCount : number;
    singleSampleRedoCount :number;
    channels : Array<Channel>;
    sampleResults : Array<Result>;
    sampleType : string;
}